/* Inter Aurum – Resat Silber · Theme-Script
   Läuft identisch in der statischen Vorschau und im Shopify-Theme.
   Im Shopify-Theme spricht der Warenkorb die Shopify Ajax-API an,
   in der Vorschau einen lokalen Warenkorb (localStorage). */
(() => {
  'use strict';

  const IA = window.IA || {};
  const SHIP = Object.assign({ base: 695, high: 1390, threshold: 40000 }, IA.shipping || {});
  const isShopify = IA.mode === 'shopify';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  const money = cents => new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format((cents || 0) / 100);
  const shippingFor = subtotal => (subtotal <= 0 ? 0 : subtotal > SHIP.threshold ? SHIP.high : SHIP.base);
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Cart adapters ---------- */
  const LocalCart = {
    key: 'ia-cart-v1',
    read() { try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; } },
    write(lines) { try { localStorage.setItem(this.key, JSON.stringify(lines)); } catch (e) { /* privater Modus */ } },
    async get() {
      const catalog = IA.products || {};
      const items = this.read().filter(l => catalog[l.id]).map(l => {
        const p = catalog[l.id];
        return { key: l.id, id: l.id, title: p.title, image: p.image, url: p.url, price: p.price, quantity: l.qty, line_price: p.price * l.qty, variant_title: p.weight || '' };
      });
      const total = items.reduce((s, i) => s + i.line_price, 0);
      return { items, total_price: total, item_count: items.reduce((s, i) => s + i.quantity, 0) };
    },
    async add(id, qty) {
      const lines = this.read(); const line = lines.find(l => l.id === id);
      if (line) line.qty += qty; else lines.push({ id, qty });
      this.write(lines); return this.get();
    },
    async change(key, qty) {
      let lines = this.read();
      lines = qty > 0 ? lines.map(l => (l.id === key ? { ...l, qty } : l)) : lines.filter(l => l.id !== key);
      this.write(lines); return this.get();
    }
  };

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const ShopifyCart = {
    async get() { return (await fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })).json(); },
    async add(id, qty) {
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }) });
      if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.description || 'Der Artikel konnte nicht hinzugefügt werden.'); }
      return this.get();
    },
    async change(key, qty) {
      const r = await fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
      return r.json();
    }
  };
  const Cart = isShopify ? ShopifyCart : LocalCart;

  /* ---------- Cart rendering ---------- */
  const imgUrl = (src, w) => {
    if (!src) return '';
    if (isShopify && /cdn\.shopify\.com|\/cdn\/shop\//.test(src)) return src + (src.includes('?') ? '&' : '?') + 'width=' + w;
    return src;
  };

  // Mitgelieferte Produktfotos (Theme-Einstellung) haben Vorrang vor den Admin-Bildern
  const lineImage = item => (IA.productImages && IA.productImages[item.handle]) || imgUrl(item.image || (item.featured_image && item.featured_image.url), 240);

  function lineHTML(item) {
    return `<div class="cart-line" data-key="${esc(item.key)}">
      <a class="cart-line__img" href="${esc(item.url)}"><img src="${esc(lineImage(item))}" alt="" loading="lazy"></a>
      <div>
        <a href="${esc(item.url)}"><p class="cart-line__title">${esc(item.product_title || item.title)}</p></a>
        <div class="cart-line__unit">${money(item.final_price || item.price)} / Stück</div>
        <div class="cart-line__actions">
          <div class="qty"><button type="button" data-qty="-1" aria-label="Menge verringern">−</button><input type="number" min="0" value="${item.quantity}" aria-label="Menge"><button type="button" data-qty="1" aria-label="Menge erhöhen">+</button></div>
          <button type="button" class="cart-line__remove" data-remove>Entfernen</button>
        </div>
      </div>
      <div class="cart-line__total">${money(item.final_line_price || item.line_price)}</div>
    </div>`;
  }

  function summaryHTML(cart) {
    const sub = cart.total_price; const ship = shippingFor(sub);
    return `<div class="summary">
      <div class="summary__row"><span>Zwischensumme</span><span>${money(sub)}</span></div>
      <div class="summary__row"><span>Versand &amp; Verpackung<small>Deutschland</small></span><span>${money(ship)}</span></div>
      <div class="summary__row summary__row--total"><span>Gesamt</span><span>${money(sub + ship)}</span></div>
      <small>inkl. gesetzlicher MwSt. · Endgültige Versandkosten werden an der Kasse bestätigt.</small>
    </div>`;
  }

  const emptyHTML = `<div class="cart-empty"><svg viewBox="0 0 48 48" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M8 18h32l-3 22H11z"/><path d="M17 18v-4a7 7 0 0 1 14 0v4"/></svg><p class="h3">Ihr Warenkorb ist leer</p><p class="small">Entdecken Sie unsere Silberbarren und Resat Münzen.</p><a class="btn" href="${esc(IA.shopUrl || '/collections/all')}" style="margin-top:18px">Zum Shop</a></div>`;

  function renderCart(cart) {
    $$('.cart-count').forEach(el => {
      const before = el.textContent; el.textContent = cart.item_count;
      el.classList.toggle('has-items', cart.item_count > 0);
      if (before !== String(cart.item_count)) { el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
    });
    $$('[data-cart-lines]').forEach(el => { el.innerHTML = cart.items.length ? cart.items.map(lineHTML).join('') : emptyHTML; });
    $$('[data-cart-summary]').forEach(el => { el.innerHTML = cart.items.length ? summaryHTML(cart) : ''; el.closest('[data-cart-foot]')?.toggleAttribute('hidden', !cart.items.length); });
  }

  async function refreshCart() { try { renderCart(await Cart.get()); } catch (e) { console.error(e); } }

  document.addEventListener('click', async e => {
    const line = e.target.closest('.cart-line');
    if (!line) return;
    const key = line.dataset.key; const input = $('input', line);
    if (e.target.closest('[data-remove]')) { line.style.opacity = '.4'; renderCart(await Cart.change(key, 0)); }
    const step = e.target.closest('[data-qty]');
    if (step) { const q = Math.max(0, Number(input.value) + Number(step.dataset.qty)); input.value = q; line.style.opacity = '.6'; renderCart(await Cart.change(key, q)); }
  });
  document.addEventListener('change', async e => {
    const line = e.target.closest('.cart-line'); if (!line || e.target.tagName !== 'INPUT') return;
    renderCart(await Cart.change(line.dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0)));
  });

  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-checkout]'); if (!btn) return;
    if (isShopify) { e.preventDefault(); window.location.href = root + 'checkout'; return; }
    e.preventDefault(); toast('Vorschau: Im Shopify-Shop führt dieser Button direkt zur sicheren Kasse.');
  });

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id); if (!d) return;
    lastFocus = document.activeElement; d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => $('.drawer__panel [data-close], .drawer__panel a, .drawer__panel button', d)?.focus(), 50);
  }
  function closeDrawers() {
    $$('.drawer.is-open').forEach(d => { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    document.documentElement.style.overflow = '';
    lastFocus?.focus?.();
  }
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); if (opener.dataset.open === 'cart-drawer') refreshCart(); openDrawer(opener.dataset.open); }
    if (e.target.closest('[data-close]') || e.target.classList.contains('drawer__scrim')) closeDrawers();
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    let t = $('.toast'); if (!t) { t = document.createElement('div'); t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-visible'); clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('is-visible'), 3800);
  }

  /* ---------- Add to cart (with fly-to-cart animation) ---------- */
  function flyToCart(fromImg) {
    const target = $('.header [data-open="cart-drawer"]'); if (!fromImg || !target || reduceMotion) return Promise.resolve();
    const a = fromImg.getBoundingClientRect(); const b = target.getBoundingClientRect();
    const f = document.createElement('div'); f.className = 'fly';
    f.innerHTML = `<img src="${esc(fromImg.currentSrc || fromImg.src)}" alt="" style="width:100%;height:100%;object-fit:cover">`;
    f.style.left = a.left + a.width / 2 - 35 + 'px'; f.style.top = a.top + a.height / 2 - 35 + 'px';
    document.body.appendChild(f);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      f.style.transform = `translate(${b.left + b.width / 2 - (a.left + a.width / 2)}px, ${b.top + b.height / 2 - (a.top + a.height / 2)}px) scale(.25)`;
      f.style.opacity = '.3';
    }));
    return new Promise(res => setTimeout(() => { f.remove(); res(); }, 850));
  }

  document.addEventListener('submit', async e => {
    const form = e.target.closest('[data-add-to-cart]'); if (!form) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form); const label = btn?.innerHTML;
    const id = form.dataset.variant || $('[name="id"]', form)?.value;
    const qty = Math.max(1, parseInt($('[name="quantity"]', form)?.value, 10) || 1);
    if (btn) { btn.disabled = true; btn.innerHTML = 'Wird hinzugefügt …'; }
    try {
      const img = document.querySelector(form.dataset.image || '.gallery-main img.is-active') || form.closest('.card')?.querySelector('img');
      const [cart] = await Promise.all([Cart.add(id, qty), flyToCart(img)]);
      renderCart(cart); openDrawer('cart-drawer');
    } catch (err) { toast(err.message); }
    finally { if (btn) { btn.disabled = false; btn.innerHTML = label; } }
  });

  /* ---------- Quantity steppers on product page ---------- */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-step]'); if (!b) return;
    const input = b.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.dataset.step));
  });

  /* ---------- Header ---------- */
  const header = $('.header');
  const onScrollHeader = () => header?.classList.toggle('is-scrolled', window.scrollY > 40);

  /* ---------- Reveal on scroll ---------- */
  const io = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
  }, { rootMargin: '0px 0px -12% 0px', threshold: .08 }) : null;
  $$('.reveal, .stagger, .draw-line').forEach(el => (io ? io.observe(el) : el.classList.add('is-in')));

  /* ---------- Collection filters ---------- */
  $$('[data-filter]').forEach(chip => chip.addEventListener('click', () => {
    const f = chip.dataset.filter;
    $$('[data-filter]').forEach(c => c.classList.toggle('is-active', c === chip));
    $$('[data-type]').forEach(card => card.classList.toggle('is-filtered', f !== 'all' && card.dataset.type !== f));
  }));

  /* ---------- Product gallery ---------- */
  const main = $('.gallery-main');
  if (main) {
    const imgs = $$('img', main);
    $$('.thumbs button').forEach((t, i) => t.addEventListener('click', () => {
      imgs.forEach((im, j) => { im.classList.toggle('is-active', i === j); im.style.opacity = i === j ? 1 : 0; });
      $$('.thumbs button').forEach((b, j) => b.classList.toggle('is-active', i === j));
    }));
    main.addEventListener('pointermove', e => {
      const r = main.getBoundingClientRect();
      $$('img', main).forEach(im => { im.style.transformOrigin = `${((e.clientX - r.left) / r.width) * 100}% ${((e.clientY - r.top) / r.height) * 100}%`; });
    });
    main.addEventListener('click', () => main.classList.toggle('is-zoom'));
    main.addEventListener('pointerleave', () => main.classList.remove('is-zoom'));
  }

  /* ---------- Sticky buy bar ---------- */
  const stickyBuy = $('.sticky-buy'); const buyAnchor = $('[data-buy-anchor]');
  if (stickyBuy && buyAnchor && io) {
    new IntersectionObserver(([en]) => stickyBuy.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(buyAnchor);
  }

  /* ---------- Contact form (preview only) ---------- */
  $$('[data-preview-form]').forEach(f => f.addEventListener('submit', e => {
    e.preventDefault();
    const s = $('.form-status', f) || f.appendChild(Object.assign(document.createElement('div'), { className: 'form-status form-status--ok' }));
    s.textContent = 'Vorschau: Im Shopify-Shop wird Ihre Nachricht an info@inter-aurum.de gesendet.';
  }));

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (ticking) return; ticking = true;
    requestAnimationFrame(() => { ticking = false; onScrollHeader(); });
  }, { passive: true });

  /* ---------- Boot ---------- */
  function boot() {
    document.documentElement.classList.add('is-loaded');
    onScrollHeader(); refreshCart();
  }
  if (document.readyState === 'complete') boot(); else window.addEventListener('load', boot);
  document.addEventListener('DOMContentLoaded', onScrollHeader);
  window.IACart = { refresh: refreshCart, money, shippingFor };
})();
